import Content from './Content/Content'
import Options from './Options/Options'

const HomeContainer = () => {
    return (
        <>
            <Content />
            <Options />
        </>
    )
}

export default HomeContainer